import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getAllBanner = createAsyncThunk(
  "admin/allBanner",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/banner/all`, {
        headers: authHeader(),
      });
      return response; 
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSingleBanner = createAsyncThunk(
  "admin/singleBanner",
  async (BannerId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/banner/${BannerId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addBanner = createAsyncThunk(
  "admin/addBanner",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/banner/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const editBanner = createAsyncThunk(
  "admin/editBanner",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/banner/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteBanner = createAsyncThunk(
  "admin/deleteBanner",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/banner/delete/${selectedId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
const initialState = {};

const bannerSlice = createSlice({
  name: "bannerSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllBanner.fulfilled, (state, action) => {
      state.bannerData = action.payload.data;
    });
    builder.addCase(getSingleBanner.fulfilled, (state, action) => {
      state.singleBannerData = action.payload.data;
    });
  },
});
export default bannerSlice.reducer;
